import {
  FiAward,
  FiBriefcase,
  FiCode,
  FiFacebook,
  FiFileText,
  FiGithub,
  FiGrid,
  FiImage,
  FiInstagram,
  FiLinkedin,
  FiMail,
  FiTag,
} from "react-icons/fi";
import { SiLeetcode } from "react-icons/si";

// Sidebar navigation (portfolio content mapped to LeetCode sections).
export const NAV_ITEMS = [
  { to: "/", label: "Dashboard", icon: FiGrid, end: true },
  { to: "/problems", label: "Problems", icon: FiCode },
  { to: "/experience", label: "Experience", icon: FiBriefcase },
  { to: "/topics", label: "Topics", icon: FiTag },
  { to: "/badges", label: "Badges", icon: FiAward },
  { to: "/gallery", label: "Gallery", icon: FiImage },
  { to: "/resume", label: "Resume", icon: FiFileText },
  { to: "/contact", label: "Contact", icon: FiMail },
];

export const SOCIAL_ICONS = {
  github: FiGithub,
  linkedin: FiLinkedin,
  leetcode: SiLeetcode,
  facebook: FiFacebook,
  instagram: FiInstagram,
};

// Resolve a page title from a pathname (handles nested /problems/:slug).
export const titleForPath = (pathname) => {
  if (pathname.startsWith("/problems/")) return "Problem";
  const match = NAV_ITEMS.find((n) =>
    n.end ? pathname === n.to : pathname.startsWith(n.to)
  );
  return match ? match.label : "Dashboard";
};
